import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session';
import thunk from 'redux-thunk';
import activePolicyReducer from './features/activePolicySlice';
import addUserReducer from './features/addUserSlice';
import alertReducer from './features/alertSlice';
import authReducer from './features/authSlice';
import boardColumnReducer from './features/boardColumnSlice';
import chartsReducer from './features/chartsSlice.js';
import complianceReducer from './features/complianceSlice';
import darkmodeReducer from './features/darkmodeSlice';
import dashboardWidgetReducer from './features/dashboardWidgetSlice';
import funcReducer from './features/funcSlice';
import inActivePolicyReducer from './features/inActivePolicySlice';
import loadingReducer from './features/loadingSlice';
import notificationReducer from './features/notificationSlice';
import notificationsReducer from './features/notificationsSlice';
import previousRouteReducer from './features/previousRouteSlice';
import privacyPagePermissionReducer from './features/privacyPagePermissionSlice';
import privacyReducer from './features/privacyPersistedSlice';
import privacyNpReducer from './features/privacySlice';
import toggleSidebarReducer from './features/toggleSidebarSlice';
import updateUserReducer from './features/updateUserSlice';
import userSettingsReducer from './features/userSettingsSlice';
import orgSelectReducer from './features/orgSelectSlice';

// makePersisted is a helper function for creating persisted (stored, in local or session storage) redux slices
// customStorage is an optional parameter to use a different storage type from localStorage, for example sessionStorage
const makePersisted = (key, reducer, customStorage = storage) => persistReducer({ key, storage: customStorage }, reducer);

const combinedReducer = combineReducers({
  authState: authReducer,
  funcState: funcReducer,
  loading: loadingReducer,
  alerts: alertReducer,
  addUser: addUserReducer,
  previousRoute: previousRouteReducer,
  dark: darkmodeReducer,
  notification: notificationReducer,
  toggleSidebar: makePersisted('toggleSidebar', toggleSidebarReducer),
  updateUser: updateUserReducer,
  notifications: notificationsReducer,
  charts: chartsReducer,
  dashboardWidget: dashboardWidgetReducer,
  inActivePolicy: inActivePolicyReducer,
  ActivePolicy: makePersisted('ActivePolicy', activePolicyReducer),
  privacyPagePermission: privacyPagePermissionReducer,
  boardColumn: makePersisted('boardColumn', boardColumnReducer),
  privacyPersisted: makePersisted('privacy', privacyReducer),
  privacy: privacyNpReducer,
  compliance: complianceReducer,
  userSettings: userSettingsReducer,
  orgSelect: makePersisted('orgSelect', orgSelectReducer, storageSession),
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_APP') {
    const preservedState = {};
    const keysToPreserve = action.preserveKeys || [];

    for (const key of keysToPreserve) {
      if (state?.[key] !== undefined) {
        preservedState[key] = state[key];
      }
    }

    return combinedReducer(preservedState, action);
  }

  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk],
});

export const persistor = persistStore(store);
